( function () {
	'use strict';

	function initTeamGrid( section ) {
		const cards    = section.querySelectorAll( '.team-grid__card' );
		let modal      = section.querySelector( '.team-grid__modal' );

		if ( ! cards.length || ! modal ) return;

		// Move modal to <body> so position:fixed is always viewport-relative,
		// escaping any transform/will-change stacking context on the section.
		if ( modal.parentElement !== document.body ) {
			document.body.appendChild( modal );
		}

		const backdrop = modal.querySelector( '.team-grid__modal-backdrop' );
		const closeBtn = modal.querySelector( '.team-grid__modal-close' );

		// Modal elements
		const modalPhoto     = modal.querySelector( '.team-grid__modal-photo' );
		const modalName      = modal.querySelector( '.team-grid__modal-name' );
		const modalBio       = modal.querySelector( '.team-grid__modal-bio' );
		const modalEmail     = modal.querySelector( '.team-grid__modal-link--email' );
		const modalPhone     = modal.querySelector( '.team-grid__modal-link--phone' );
		const modalInstagram = modal.querySelector( '.team-grid__modal-link--instagram' );
		const modalHandle    = modal.querySelector( '.team-grid__modal-instagram-handle' );

		let lastFocused = null;

		function openModal( card ) {
			const name      = card.dataset.name      || '';
			const jobTitle  = card.dataset.jobTitle  || '';
			const photo     = card.dataset.photo     || '';
			const photoAlt  = card.dataset.photoAlt  || name;
			const bio       = card.dataset.bio       || '';
			const email     = card.dataset.email     || '';
			const phone     = card.dataset.phone     || '';
			const instagram = card.dataset.instagram || '';

			if ( modalPhoto ) {
				modalPhoto.src = photo;
				modalPhoto.alt = photoAlt;
			}

			if ( modalName ) {
				modalName.innerHTML = name + ( jobTitle ? ' <span style="font-weight:400;">| ' + jobTitle + '</span>' : '' );
			}

			if ( modalBio ) modalBio.textContent = bio;

			if ( modalEmail ) {
				modalEmail.href = email ? 'mailto:' + email : '';
			}

			if ( modalPhone ) {
				const cleaned = phone.replace( /\D/g, '' );
				modalPhone.href = phone ? 'tel:+1' + cleaned : '';
			}

			if ( modalInstagram ) {
				modalInstagram.href = instagram ? 'https://instagram.com/' + instagram : '';
				if ( modalHandle ) modalHandle.textContent = instagram ? '@' + instagram : '';
			}

			lastFocused = document.activeElement;
			modal.removeAttribute( 'hidden' );
			document.body.style.overflow = 'hidden';

			if ( closeBtn ) closeBtn.focus();
		}

		function closeModal() {
			modal.setAttribute( 'hidden', '' );
			document.body.style.overflow = '';
			if ( lastFocused ) lastFocused.focus();
		}

		cards.forEach( function ( card ) {
			card.addEventListener( 'click', function () {
				openModal( card );
			} );

			card.addEventListener( 'keydown', function ( e ) {
				if ( e.key === 'Enter' || e.key === ' ' ) {
					e.preventDefault();
					openModal( card );
				}
			} );
		} );

		if ( closeBtn ) closeBtn.addEventListener( 'click', closeModal );
		if ( backdrop ) backdrop.addEventListener( 'click', closeModal );

		document.addEventListener( 'keydown', function ( e ) {
			if ( e.key === 'Escape' && ! modal.hasAttribute( 'hidden' ) ) {
				closeModal();
			}
		} );
	}

	function boot() {
		document.querySelectorAll( '.team-grid' ).forEach( initTeamGrid );
	}

	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', boot );
	} else {
		boot();
	}

	if ( typeof wp !== 'undefined' && wp.domReady ) {
		wp.domReady( function () {
			boot();

			const observer = new MutationObserver( function ( mutations ) {
				mutations.forEach( function ( mutation ) {
					mutation.addedNodes.forEach( function ( node ) {
						if ( ! ( node instanceof HTMLElement ) ) return;

						const sections = node.classList.contains( 'team-grid' )
							? [ node ]
							: Array.from( node.querySelectorAll( '.team-grid' ) );

						sections.forEach( initTeamGrid );
					} );
				} );
			} );

			observer.observe( document.body, { childList: true, subtree: true } );
		} );
	}

}() );